import React from "react";
import { OperatorDashboard } from "../interfaces/OperatorsBalanceDashboard";
import { OperatorsBalanceDashboardEscrowTable } from "./OperatorsBalanceDashboardEscrowTable";
import { OperatorsBalanceDashboardSCTable } from "./OperatorsBalanceDashboardSCTable";
import { InstitutionAttributesMap } from "../interfaces/Institution";

type OperatorDashboardTableProps = {
    operatorDashboard: OperatorDashboard
    attributes?: InstitutionAttributesMap | null
}

export const OperatorsBalanceDashboardTable = ({ operatorDashboard, attributes }: OperatorDashboardTableProps) => {

    const operatorInfos = operatorDashboard?.operator_infos || [];
    const instanceInfos = operatorDashboard?.instance_infos || [];

    return (
        <>
            <OperatorsBalanceDashboardEscrowTable escrowInfos={operatorInfos} attributes={attributes}/>
            <OperatorsBalanceDashboardSCTable scInfo={instanceInfos} attributes={attributes}/>
        </>
    );
}